import { loadChatSdk } from "./loadSdk";

type Messenger = typeof import("@origin-digital/chat-client-sdk")["Messenger"];

let messengerPromise: Promise<Messenger> | undefined;

function getMessenger(): Promise<Messenger> {
  if (!messengerPromise) {
    messengerPromise = loadChatSdk()
      .then((sdk) => sdk.Messenger)
      .catch((error) => {
        // Allow a later launcher operation to retry after a failed chunk load.
        messengerPromise = undefined;
        throw error;
      });
  }

  return messengerPromise;
}

export async function open(): Promise<void> {
  const Messenger = await getMessenger();
  Messenger("boot", { showOnBoot: true });
}

export async function restore(sessionId: string): Promise<void> {
  const restoreSessionId = sessionId.trim();
  if (!restoreSessionId) {
    return;
  }

  const Messenger = await getMessenger();
  Messenger("boot", {
    showOnBoot: true,
    restoreSession: { sessionId: restoreSessionId },
  });
}
